import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=7a340b98&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=7a340b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a340b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a340b98')) {
      api.createRecord('7a340b98', component.options)
    } else {
      api.reload('7a340b98', component.options)
    }
    module.hot.accept("./companyInfo.vue?vue&type=template&id=7a340b98&scoped=true", function () {
      api.rerender('7a340b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/components/companyInfo.vue"
export default component.exports